import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;
export const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
export const SERIF = '"Cormorant Garamond", Georgia, serif';
export const SOUNDSCAPES = [["selected", "Soulumo Selected", "Recommended"], ["deep_rest", "Deep Rest"], ["soft_ambient", "Soft Ambient"], ["gentle_rain", "Gentle Rain"], ["ocean", "Ocean"]];
export const SLOT_LABEL = { morning: "Morning", midday: "Midday", evening: "Evening", night: "Night" };
export const INTENSITY = [
  ["light", "Light", "1 daytime listen"],
  ["standard", "Moderate", "2 daytime listens · recommended"],
  ["deep", "Deep", "3 daytime listens"],
];
export const tz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/London";

export const getNight = (jid) => axios.get(`${API}/api/night/by-journey/${jid}`, auth()).then((r) => r.data.night);
export const makeNight = (jid, soundscape) => axios.post(`${API}/api/night/${jid}`, { soundscape }, auth()).then((r) => r.data);
export const getPlan = () => axios.get(`${API}/api/practice`, auth()).then((r) => r.data.plan);
export const getPlanState = () => axios.get(`${API}/api/practice`, auth()).then((r) => r.data);
export const dismissHalfway = () => axios.post(`${API}/api/practice/halfway-dismiss`, {}, auth());
export const dismissComplete = () => axios.post(`${API}/api/practice/complete-dismiss`, {}, auth());
export const SLOTS_FOR = { light: ["morning"], standard: ["morning", "evening"], deep: ["morning", "midday", "evening"] };
export const startPlan = (body) => axios.post(`${API}/api/practice`, { ...body, tz: tz() }, auth()).then((r) => r.data);
export const logListen = (slot) => axios.post(`${API}/api/practice/log`, { slot }, auth()).then((r) => r.data.plan).catch(() => null);
export const createTogether = (body) => axios.post(`${API}/api/together`, { ...body, tz: tz() }, auth()).then((r) => r.data);
export const getTogether = (id) => axios.get(`${API}/api/together/${id}`).then((r) => r.data);
export const joinTogether = (id, replace = false) => axios.post(`${API}/api/together/${id}/join`, { replace, tz: tz() }, auth()).then((r) => r.data);

export const enablePush = async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return "unsupported";
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return "denied";
  const { data } = await axios.get(`${API}/api/push/vapid-key`, auth());
  if (!data.enabled) return "unsupported";
  const reg = await navigator.serviceWorker.ready;
  const raw = atob(data.vapid_key.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - (data.vapid_key.length % 4)) % 4));
  const key = Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key }));
  const j = sub.toJSON();
  await axios.post(`${API}/api/push/subscribe`, { endpoint: j.endpoint, keys: j.keys }, auth());
  return "ok";
};
